/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_Bronze_Seal_PlayInputs */

const en_green_bronze_seal_play = /** @type {(inputs: Green_Bronze_Seal_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open importer`)
};

const de_green_bronze_seal_play = /** @type {(inputs: Green_Bronze_Seal_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer öffnen`)
};

/**
* | output |
* | --- |
* | "Open importer" |
*
* @param {Green_Bronze_Seal_PlayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_bronze_seal_play = /** @type {((inputs?: Green_Bronze_Seal_PlayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Bronze_Seal_PlayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_bronze_seal_play(inputs)
	return de_green_bronze_seal_play(inputs)
});